import React from "react";
import "./Works.css";
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Amazon from "../../img/amazon.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import { motion } from "framer-motion";
const Works = () => {
  return (
    <div className="works">
      <div className="awesome">
        <span>Works for all these</span>
        <span>brands & client</span>
        <spane>
          lorem epsum is a simply tet of pricing of printing lorem epsum text
          <br />
          lorem epsum is a simply tet of pricing of printing lorem epsum text
          <br />
          lorem epsum is a simply tet of pricing of printing lorem epsum text
          <br />
          lorem epsum is a simply tet of pricing of printing lorem epsum text
        </spane>

        <button className="button s-button">Hire ME</button>

        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/*right side*/}
      <div className="w-right">
        <motion.div 
        initial={{rotate:45}}
        whileInView={{rotate:0}}
        viewport={{margin:'-40px'}}
        transition={{duration:4,type:'spring'}}
        className="w-mainCircle">
          <div className="w-secCircle">
            <img src={Upwork} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Fiverr} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Amazon} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Shopify} alt="" />
          </div>
          <div className="w-secCircle">
            <img src={Facebook} alt="" />
          </div>
        </motion.div>
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
